<template>
    <div class="card">
        <div class="card-header text-left">
            <strong>
                Risco de inadimplência {{title}} - 
                <template v-if="type == 1">
                    Contas a receber
                </template>
                <template v-else >
                    Contas a pagar
                </template>
            </strong>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                    <div class="d-flex justify-content-center">
                    <radial-progress-bar 
                        :diameter="200"
                        :completed-steps="inad"
                        :total-steps="totalSteps"
                        :isClockwise="isClock"
                        :stroke-width="20"
                        :inner-stroke-width="20"
                        inner-stroke-color="rgba(0, 0, 0, 0.3)"
                        :start-color="color"
                    >
                        <h4>{{inad + '%'}}</h4>
                    </radial-progress-bar>
                    </div>
                </div>
                <div class="col-md-6 text-center text-md-left">
                    <template v-if="type == 1" >
                        <p>
                            <small> A receber </small>
                            <strong> R${{total}} </strong>
                        </p>
                        <p>
                            <small>Recebido</small> 
                            <strong> R${{pago}} </strong>
                        </p>
                        <p>
                            <small> Inadimplênte </small>
                            <strong> R${{aberto}} </strong>
                        </p>
                    </template>
                    <template v-else >
                        <p>
                            <small> A pagar </small>
                            <strong> R${{total}} </strong>
                        </p>
                        <p>
                            <small>Pago</small> 
                            <strong> R${{pago}} </strong>
                        </p>
                        <p>
                            <small> Inadimplênte </small>
                            <strong> R${{aberto}} </strong>
                        </p>
                    </template>

                    <div class="btn-group" role="group" aria-label="Basic example">
                        <button type="button" v-bind:class="[active == 1 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 1, active = 1]" class="btn btn-sm">Esse Mês</button>
                        <button type="button" v-bind:class="[active == 2 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 12, active = 2]"  class="btn btn-sm">Esse Ano</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import RadialProgressBar from 'vue-radial-progress'
    export default {
        name: 'defaultRisk',
        components: {
            RadialProgressBar
        },
        props: [
            'type',
            'isClock',
            'color'
        ],
        data(){
            return{
                active: 1,
                period: 1,
                completedSteps: 0,
                totalSteps: 100,
                total: 0,
                pago: 0,
                aberto: 0,
                inad: 0,
                title: 'no mês'
            }
        },
		computed: {
			getToken(){
				return this.$store.getters.getToken
			}
		},
        methods:{
            getData: function(){
                // Periodo 1 = mês atual
                // Periodo 2 = ano atual
                fetch(server + 'listas/risco/' + this.period, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => ( response.json() ) )
                    .then(responseJSON => {
                        this.total  = responseJSON.response[0].total
                        this.inad   = parseInt(responseJSON.response[0].inadimplente)
                        this.aberto = responseJSON.response[0].aberto
                        this.pago   = responseJSON.response[0].pago
                    })
                    .catch(() => {
                        this.total  = 0
                        this.inad   = 0
                        this.aberto = 0
                        this.pago   = 0
                    })
            }
        },

        mounted(){
            this.getData()
        },

        watch: {
          active: function(newVal, oldVal){
            if(newVal == 1){
              this.title = 'no mês'
            }else if(newVal == 2){
              this.title = 'no ano'
            }

            this.getData()
          }
        } 
    }
</script>
<style scoped>

</style>